import { render, staticRenderFns } from "./issueDetail.vue?vue&type=template&id=eeef81d2&scoped=true&"
import script from "./issueDetail.vue?vue&type=script&lang=js&"
export * from "./issueDetail.vue?vue&type=script&lang=js&"
import style0 from "./issueDetail.vue?vue&type=style&index=0&id=eeef81d2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeef81d2",
  null
  
)

export default component.exports